/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiFieldConfig} from "./UiFieldConfig";
import {UiTextInputHandlingFieldConfig} from "./UiTextInputHandlingFieldConfig";
import {UiFieldSubCommandHandler} from "./UiFieldConfig";
import {UiTextInputHandlingFieldSubEventSource} from "./UiTextInputHandlingFieldConfig";


export interface UiCurrencyFieldConfig extends UiFieldConfig, UiTextInputHandlingFieldConfig {
	_type?: string;
	defaultCurrencyCode?: string;
	currencyCodeList?: string[];
	precision?: number;
	showCurrencyBeforeAmount?: boolean;
	showCurrencySymbol?: boolean;
	alphaKeysQueryForCurrency?: boolean
}

export interface UiCurrencyFieldSubCommandHandler extends UiFieldSubCommandHandler {
	setDefaultCurrencyCode(defaultCurrencyCode: string): void;
	setCurrencyCodeList(currencyCodeList: string[]): void;
	setShowCurrencyBeforeAmount(showCurrencyBeforeAmount: boolean): void;
	setShowCurrencySymbol(showCurrencySymbol: boolean): void;
}

export interface UiCurrencyFieldSubEventSource extends UiTextInputHandlingFieldSubEventSource {
}

